const TransactionsStrings = {
    transactionCreated: "Транзакция успешно создана"
}

export default TransactionsStrings;